import { ClassName } from '@type/component-data-types'
import * as React from 'react'

type Props = {
  children?: React.ReactNode
  className?: ClassName
}

const ArticleBody = React.memo((props: Props): React.JSX.Element => {
  const defaultCssClass = 'article__text mb-5'
  const cssClass: ClassName = props.className
    ? `${defaultCssClass} ${props.className}`
    : defaultCssClass

  return <div className={cssClass}>{props.children}</div>
})
export default ArticleBody
